// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "components-MainPage" + "." + "4420bbaf7c784234f446" + ".css";
};